import React, { Component } from 'react';
import './ActionsPage.css';
import { connect } from 'react-redux';
import CreateSiteModal from 'components/features/Commissioning/CreateSiteModal';
import ActionsTable from 'components/features/Actions/ActionsTable/ActionsTable';
import ConsoleTile from 'components/shared/ConsoleTile/ConsoleTile';
import ActionDetailsModal from 'components/features/Actions/ActionDetailsModal/ActionDetailsModal';
import ActionTwoHopProgressViewModal from 'components/features/Actions/ActionTwoHopProgressViewModal/ActionTwoHopProgressViewModal';
import { getActionsList, setPage, clearActionList, doUpdateCommissioningOp } from 'redux/actions';
import { Status } from 'apis/Status';
import TwoHopAlignment from 'components/features/TwoHopAlignment/TwoHopAlignment';
import TwoHopSettings from 'components/features/TwoHopAlignment/TwoHopSettings/TwoHopSettings';

const COMMISSION_PERMISSION_MESSAGE =
  'You don’t have a permission to perform this task. Please contact your admin for further assistance.';

class ActionsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeActionsList: [],
      pastActionsList: [],
      monitoredDetailsUrl: null,
      detailsModalOpen: false,
      twoHopProgressViewModalOpen: false,
      selectedActionId: null,
      selectedActionIsActive: false,
      commissionModalOn: false,
      twoHopModalOn: false,
      refreshActionList: false,
      showCommissionPermissionTooltip: false,
      showTwoHopPermissionTooltip: false
    };

    this.detailsOnClick = this.detailsOnClick.bind(this);
    this.setDetailsModalOpenActive = this.setDetailsModalOpenActive.bind(this);
    this.setDetailsModalOpenPast = this.setDetailsModalOpenPast.bind(this);
  }

  detailsOnClick(action) {
    this.setState({
      selectedActionId: action.instance_id,
      selectedActionIsActive:
        action.runtime_status !== 'Completed' &&
        action.runtime_status !== 'Failed' &&
        action.runtime_status !== 'Warning'
    });
  }

  twoHopProgressViewOnClick = (action) => {
    this.setState({
      selectedActionId: action?.commissioningId,
      selectedActionIsActive:
        action.runtimeStatus !== 'Completed' && action.runtimeStatus !== 'Failed' && action.runtimeStatus !== 'Warning'
    });
  };

  setDetailsModalOpenActive(isOpen) {
    this.setState({ detailsModalOpen: isOpen, actionsModalDetailType: 'active' });
  }

  setDetailsModalOpenPast(isOpen) {
    this.setState({ detailsModalOpen: isOpen, actionsModalDetailType: 'past' });
  }

  setTwoHopProgressViewModalOpenActive = (isOpen) => {
    this.setState({ twoHopProgressViewModalOpen: isOpen, actionsModalViewType: 'active' });
  };

  setTwoHopProgressViewModalOpenPast = (isOpen) => {
    this.setState({ twoHopProgressViewModalOpen: isOpen, actionsModalViewType: 'past' });
  };

  componentDidMount() {
    const canCommission = this.hasCommissionPermission();
    this.props.dispatch(setPage('ActionsPage'));
    this.props.dispatch(getActionsList(canCommission));
  }

  componentDidUpdate(prevProps, prevState) {
    const { refreshActionList } = this.state;
    if (prevState.refreshActionList === false && prevState.refreshActionList !== refreshActionList) {
      refreshActionList && this.props.dispatch(clearActionList());
      const canCommission = this.hasCommissionPermission();
      refreshActionList && canCommission && this.props.dispatch(getActionsList(canCommission));
      this.setState({ refreshActionList: false });
    }
  }

  hasCommissionPermission() {
    if (!Array.isArray(this.props.permissions)) return false;

    const COMMISSION_PERMISSION_NAME = 'cgs_commission';
    const SEARCH_COMMISSION_PERMISSION_NAME = 'cgs_search';

    const SW_DEFAULT_SWVERSION_READ = 'sw_default_swversion_read';
    const SW_PROTECTED_DEVICE_READ = 'sw_protected_device_read';
    const SW_FACTORY_DEVICE_READ = 'sw_factory_device_read';

    if (
      !this.props.permissions.includes(COMMISSION_PERMISSION_NAME) ||
      !this.props.permissions.includes(SEARCH_COMMISSION_PERMISSION_NAME) ||
      !this.props.permissions.includes(SW_DEFAULT_SWVERSION_READ) ||
      !this.props.permissions.includes(SW_PROTECTED_DEVICE_READ) ||
      !this.props.permissions.includes(SW_FACTORY_DEVICE_READ)
    ) {
      return false;
    }

    return true;
  }

  render() {
    let activeTileHeader = (
      <div className="tileHeaderContainer">
        <span className="headerTitle">{'Active actions'}</span>
      </div>
    );

    let pastTileHeader = (
      <div className="tileHeaderContainer">
        <span className="headerTitle">{'Past actions'}</span>
      </div>
    );

    let selectedAction = null;
    if (this.state.selectedActionId != null) {
      if (this.state.selectedActionIsActive) {
        selectedAction = this.props.actionsList.active[this.state.selectedActionId];
      } else {
        selectedAction = this.props.actionsList.past[this.state.selectedActionId];
      }
    }

    // console.log("action page render", this.state.monitoredDetailsUrl)
    // console.log("selectedActionId", this.state.selectedActionId);
    const canCommission = this.hasCommissionPermission();
    const fetching = canCommission
      ? this.props.getSwUpdateRequestStatus === Status.PENDING ||
        this.props.getCommissioningRequestStatus === Status.PENDING
      : this.props.getSwUpdateRequestStatus === Status.PENDING;

    const fetchingError =
      this.props.getSwUpdateRequestStatus === Status.FAILURE ||
      this.props.getCommissioningRequestStatus === Status.FAILURE;

    return (
      <div className="pageStyle">
        <div className="actionsPageTitle">
          Actions
          {canCommission ? (
            <div
              className="ActionPage_CommissionButton_Enabled"
              onClick={() => this.setState({ commissionModalOn: true })}
            >
              Commission Pivot
            </div>
          ) : (
            <div className="ActionPage_CommissionButton_Disabled_Container">
              <div
                className="ActionPage_CommissionButton_Disabled"
                onMouseEnter={() => this.setState({ showCommissionPermissionTooltip: true })}
                onMouseLeave={() => this.setState({ showCommissionPermissionTooltip: false })}
              >
                Commission Pivot
              </div>
              {this.state.showCommissionPermissionTooltip && (
                <div className="ActionPage_CommissionButton_Disabled_Tooltip">{COMMISSION_PERMISSION_MESSAGE}</div>
              )}
            </div>
          )}
          {/* {
            <div className="ActionPage_CommissionButton_Enabled" onClick={() => this.setState({ twoHopModalOn: true })}>
              Two-Hop Alignment
            </div>
          } */}
          {canCommission ? (
            <div className="ActionPage_CommissionButton_Enabled" onClick={() => this.setState({ twoHopModalOn: true })}>
              Two-Hop Alignment
            </div>
          ) : (
            <div className="ActionPage_CommissionButton_Disabled_Container">
              <div
                className="ActionPage_CommissionButton_Disabled"
                onMouseEnter={() => this.setState({ showTwoHopPermissionTooltip: true })}
                onMouseLeave={() => this.setState({ showTwoHopPermissionTooltip: false })}
              >
                Two-Hop Alignment
              </div>
              {this.state.showTwoHopPermissionTooltip && (
                <div className="ActionPage_CommissionButton_Disabled_Tooltip">{COMMISSION_PERMISSION_MESSAGE}</div>
              )}
            </div>
          )}
        </div>

        {this.state.commissionModalOn && (
          <CreateSiteModal onClose={() => this.setState({ commissionModalOn: false })} actionsPageThis={this} />
        )}

        {this.state.twoHopModalOn && (
          <TwoHopAlignment onClose={() => this.setState({ twoHopModalOn: false })} actionsPageThis={this} />
        )}

        {this.state.detailsModalOpen && selectedAction != null && (
          <ActionDetailsModal
            actionType={'BulkSoftwareUpdate'}
            action={selectedAction}
            actionTableType={this.state.actionsModalDetailType}
            setDetailsModalOpen={(isOpen) => this.setState({ detailsModalOpen: isOpen })}
          />
        )}

        {this.state.twoHopProgressViewModalOpen && selectedAction != null && (
          <ActionTwoHopProgressViewModal
            actionType={'TwoHopAlignment'}
            action={selectedAction}
            actionTableType={this.state.actionsModalViewType}
            setTwoHopProgressViewModalOpen={(isOpen) => this.setState({ twoHopProgressViewModalOpen: isOpen })}
            actionsPageThis={this}
          />
        )}
        <div className="activeActionsTableContainer">
          <ConsoleTile tileHeader={activeTileHeader}>
            <ActionsTable
              id="active"
              data={this.props.actionsList.active}
              detailsOnClick={this.detailsOnClick}
              twoHopProgressViewOnClick={this.twoHopProgressViewOnClick}
              setDetailsModalOpen={this.setDetailsModalOpenActive}
              setTwoHopProgressViewModalOpen={this.setTwoHopProgressViewModalOpenActive}
              fetching={fetching}
              error={fetchingError}
            />
          </ConsoleTile>
        </div>

        <div className="pastActionsTableContainer">
          <ConsoleTile tileHeader={pastTileHeader}>
            <ActionsTable
              id="past"
              data={this.props.actionsList.past}
              detailsOnClick={this.detailsOnClick}
              twoHopProgressViewOnClick={this.twoHopProgressViewOnClick}
              setDetailsModalOpen={this.setDetailsModalOpenPast}
              setTwoHopProgressViewModalOpen={this.setTwoHopProgressViewModalOpenPast}
              fetching={fetching}
              error={fetchingError}
            />
          </ConsoleTile>
        </div>
      </div>
    );
  }
}

export default connect((store) => {
  return {
    actionsList: store.data.actionsList,
    permissions: store.data?.rolePermissions?.permissions,
    getSwUpdateRequestStatus: store.statuses.GetActions,
    getCommissioningRequestStatus: store.statuses.GetCommissioningActions
  };
})(ActionsPage);
